import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import {
  shoppingCartList,
  setUploadQuantity,
  clearShoppingCart,
} from 'gatsby-theme-kn/src/utils/media_database_shopping_cart'
import MediaDatabasePromotialOrderItem from 'gatsby-theme-kn/src/components/technical/MediaDatabasePromotialOrderItem'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalMediaDatabasePromotialOrder = ({ whoami, setter }) => {
  const { t } = useTranslation()

  const [Fdata, setFdata] = useState(false)
  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const d = new FormData()
    shoppingCartList().map((item, index) => {
      if (item[2] == 'upload_set') {
        d.append('promotional_order[data_sets][' + index + '][]', item[0])
        d.append('promotional_order[data_sets][' + index + '][]', item[1])
      } else {
        d.append('promotional_order[data][' + index + '][]', item[0])
        d.append('promotional_order[data][' + index + '][]', item[1])
      }
    })
    d.append(
      'promotional_order[delivery_address]',
      [
        InputData.company_name,
        InputData.first_name + ' ' + InputData.last_name,
        InputData.street,
        InputData.postal_code + ' ' + InputData.city,
        InputData.country,
      ].join('\n')
    )

    setFdata(d)
    setPartnerPortalUrl(apiURL('promotional_orders'))

    // return true
  }

  const [InputData, setInputData] = useState({
    company_name: '',
    first_name: '',
    last_name: '',
    street: '',
    postal_code: '',
    city: '',
    country: '',
  })

  useEffect(() => {
    if (whoami) {
      setInputData({
        company_name: whoami?.user.company_name,
        first_name: whoami?.user.first_name,
        last_name: whoami?.user.last_name,
        street: whoami?.user.street,
        postal_code: whoami?.user.postal_code,
        city: whoami?.user.city,
        country: whoami?.user.country,
      })
    }
  }, [whoami])

  useEffect(() => {
    if (error && error.errors && error.errors.data) {
      error.errors.data.map((e) => {
        let errorType = e.split(' ')[0]
        let reference = e.split(' ')[1].replace(/[\(|\)]/g, '')
        let id = reference.split('id:')[1].split(';')[0]
        let quantity = reference.split('quantity:')[1]
        if (errorType == 'not_enough_stock' && quantity) {
          // max. setzen
          setUploadQuantity(id, quantity, setter)
          // API URL zurücksetzen, damit wieder submitted werden kann
          setPartnerPortalUrl(apiURL(null))
        }
      })
    }
  }, [error])

  useEffect(() => {
    if (
      data &&
      data.message &&
      data.message == 'resource created successfully.'
    ) {
      clearShoppingCart(setter)
    }
  }, [data])

  return (
    <>
      {loading && <LoadingSpinner />}
      {data && <p>{t('generic.spa.media.index.order_success_body')}</p>}
      {!data && (
        <form>
          {error && (
            <div className="alert alert-danger">
              <h4>
                {t('generic.spa.media.index.order_above_maximum_headline')}
              </h4>
              <p>{t('generic.spa.media.index.order_above_maximum_body')}</p>
            </div>
          )}
          <div className="form-label-group mb-1">
            <label htmlFor="company_name">
              {t('generic.user.company_name')}
            </label>
            <input
              type="text"
              className="form-control"
              name="company_name"
              defaultValue={InputData.company_name}
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  company_name: e.target.value,
                })
              }
            />
          </div>
          <div className="row form-group mb-1">
            <div className="form-label-group col-md-6">
              <label htmlFor="first_name">
                * {t('generic.user.first_name')}
              </label>
              <input
                type="text"
                className="form-control"
                name="first_name"
                required
                defaultValue={InputData.first_name}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    first_name: e.target.value,
                  })
                }
              />
            </div>
            <div className="form-label-group col-md-6">
              <label htmlFor="last_name">* {t('generic.user.last_name')}</label>
              <input
                type="text"
                className="form-control"
                name="last_name"
                required
                defaultValue={InputData.last_name}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    last_name: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="form-label-group mb-1">
            <label htmlFor="street">* {t('generic.user.street')}</label>
            <input
              type="text"
              className="form-control"
              name="street"
              required
              defaultValue={InputData.street}
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  street: e.target.value,
                })
              }
            />
          </div>
          <div className="row">
            <div className="form-label-group mb-1 col-md-6">
              <label htmlFor="postal_code">
                * {t('generic.user.postal_code')}
              </label>
              <input
                type="text"
                className="form-control"
                name="postal_code"
                required
                defaultValue={InputData.postal_code}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    postal_code: e.target.value,
                  })
                }
              />
            </div>
            <div className="form-label-group mb-1 col-md-6">
              <label htmlFor="city">* {t('generic.user.city')}</label>
              <input
                type="text"
                className="form-control"
                name="city"
                required
                defaultValue={InputData.city}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    city: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="form-label-group mb-1">
            <label htmlFor="country">* {t('generic.user.country')}</label>
            <select
              className="form-control"
              name="country"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  country: e.target.value,
                })
              }
            >
              {['de', 'nl', 'ch', 'fr', 'gb', 'at', 'be', 'lu'].map(
                (country_code, index) => (
                  <option
                    key={index}
                    value={country_code.toUpperCase()}
                    // selected={`whoami?.user.country === country_code.toUpperCase() ? 'selected' : ''`}
                  >
                    {t('generic.user.countries.' + country_code)}
                  </option>
                )
              )}
              <option value="">{t('generic.user.countries.other')}</option>
            </select>
          </div>
          <label>{t('generic.spa.media.index.media_cart')}</label>
          <ul
            className="media-cart-list list-inline"
            style={{ whiteSpace: 'normal' }}
          >
            {shoppingCartList().map((item, index) => (
              <MediaDatabasePromotialOrderItem
                item={item}
                displaySetsRecursive={true}
              />
            ))}
          </ul>
          <hr />
          <div style={{ float: 'right' }}>
            <button className="btn btn-primary" onClick={(e) => FormSubmit(e)}>
              {t('generic.spa.media.index.order')}
            </button>
          </div>
        </form>
      )}
    </>
  )
}

export default ModalMediaDatabasePromotialOrder
